const isBlankRow = (row: string[]): boolean => row.every((cell) => cell.trim() === "");

// Copying a line out of chat leaves a leading/trailing newline; AG-Grid would paste that blank
// row into the selected cell and shift the real content down. Interior blank rows are kept.
export function trimBlankEdgeRows(data: string[][]): string[][] {
  let start = 0;
  let end = data.length;
  while (start < end && isBlankRow(data[start])) start += 1;
  while (end > start && isBlankRow(data[end - 1])) end -= 1;
  return start === 0 && end === data.length ? data : data.slice(start, end);
}
